
































import Vue from 'vue'

export default Vue.extend({
    name: 'EngramFilter',
    props: {
        manager: {
            type: Object,
            required: true,
        },
        inline: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            tagxx: [],
        }
    },
    created() {
        this.sort()
    },
    watch: {
        manager() {
            this.sort()
        },
    },
    computed: {
        css() {
            if (this.inline) {
                return 'col-3'
            }
            return 'col-12'
        },
    },
    methods: {
        sort() {
            this.tagxx = this.manager.TagManager.list.sort((aaa, bbb) => aaa.name.localeCompare(bbb.name))
        },
    },
})
